import DetailsModal from './DetailsModal'

export default DetailsModal
